import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'

// Redux-toolkit adds the following middlewares by default: [thunk, immutableStateInvariant, serializableStateInvariant]
// (https://redux-toolkit.js.org/api/getDefaultMiddleware#included-default-middleware)
// configureStore also includes by default the Redux DevTools browser extension
// (https://redux-toolkit.js.org/api/configureStore#devtools)

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: {
                ignoredPaths: ['form'],
            },
            serializableCheck: false,
        }),
})

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useTypedDispatch = () => useDispatch<AppDispatch>()
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector
